module.exports = __webpack_public_path__ + "static/honor-5fb6d4d0f355327dcf456f8e140c4082.png";